// docs: https://github.com/altostra/type-validations#readme
import { objectOf, anyOf, is } from "@altostra/type-validations";
import { string, number, boolean } from "@altostra/type-validations/lib/primitives";

export const isGetApiCalculatedAttributesIdAppGroupIdUserLookupResponse = objectOf({
  user_lookup: objectOf({
    user_id: string,
    value: anyOf(string, number, boolean, is(null)),
    has_data: boolean,
    data_type: string,
  }),
});
